"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jiraWatchers = exports.jiraReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const delete_1 = require("./delete.js");
const patch_1 = require("./patch.js");
const post_1 = require("./post.js");
const put_1 = require("./put.js");
const initiatives_1 = require("./initiatives/index.js");
const issues_1 = require("./issues/index.js");
const statuses_1 = require("./statuses/index.js");
const summary_1 = require("./summary/index.js");
exports.jiraReducers = (0, redux_1.combineReducers)({
    delete: delete_1.deleteJiraCredentialsSlice.asyncReducers,
    initiatives: initiatives_1.jiraInitiativesReducers,
    issues: issues_1.jiraIssuesReducers,
    patch: patch_1.patchJiraIntegrationSlice.asyncReducers,
    post: post_1.postJiraCredentialsSlice.asyncReducers,
    put: put_1.putJiraCredentialsSlice.asyncReducers,
    statuses: statuses_1.jiraStatusesReducers,
    summary: summary_1.jiraSummaryReducers
});
exports.jiraWatchers = (0, xuder_1.combineAllWatchers)([
    delete_1.deleteJiraCredentialsSlice.asyncWatchers,
    initiatives_1.jiraInitiativesWatchers,
    issues_1.jiraIssuesWatchers,
    patch_1.patchJiraIntegrationSlice.asyncWatchers,
    post_1.postJiraCredentialsSlice.asyncWatchers,
    put_1.putJiraCredentialsSlice.asyncWatchers,
    statuses_1.jiraStatusesWatchers,
    summary_1.jiraSummaryWatchers
]);
//# sourceMappingURL=index.js.map